import {useField, useFormikContext} from 'formik';
import React, {ReactElement} from 'react';
import {isFieldRequired, useValidationSchema} from '../form/ValidationService';
import {NxFormikProps} from '../model/SharedTypes';
import NxCheckbox, {NxCheckboxProps} from './NxCheckbox';

export type NxFormikCheckboxProps = Omit<NxCheckboxProps, NxFormikProps> & {
  name: string;
  validate?: (checked: boolean) => string | void | Promise<string | void>;
};

export const NxFormikCheckbox = (props: NxFormikCheckboxProps): ReactElement => {

  const context = useFormikContext();
  const validationSchema = useValidationSchema();

  const [field, meta, helpers] = useField({
    ...props,
    type: 'checkbox'
  });

  return <NxCheckbox {...field}
                     {...props}
                     error={meta.error}
                     checked={field.checked}
                     disabled={props.disabled || context.isSubmitting}
                     required={props.required || isFieldRequired(validationSchema, field.name)}
                     onBlur={(): void => helpers.setTouched(true, context.validateOnBlur)} />
}